import { Button } from '@svenskaspelab/ui/react/button';
import Plus from '@svenskaspelab/ui/react/icons/Plus';
import type React from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type AddCouponsButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: React.ComponentProps<typeof Button>['size'];
};

/**
 * Element containing a button to add a coupon.
 *
 * @param param0 Object containing the function to add coupon
 * @param param0.size The size of the button, either 'sm' or 'md'
 * @returns JSX.Element
 */
export default function AddCouponButton({ ...props }: AddCouponsButtonProps): ReactNode {
  return (
    <div className="bg-layer-contrast-on-base border-stroke-medium rounded-sm border px-1 py-0.5 lg:px-0 lg:py-0">
      <Button variant="ghost" aria-label="Lägg till kupong" type="submit" {...props}>
        <Plus />
      </Button>
    </div>
  );
}
